import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import ShopPage from "../pages/ShopPage";
import ReviewsPage from "../pages/ReviewsPage";
import ContactPage from "../pages/ContactPage";
import PlansPage from "../pages/PlansPage";
import NewsEventsPage from "../pages/NewsEventsPage";
import MyAccountPage from "../pages/dashboard/MyAccountPage.js";
import MealCustomization from "../pages/dashboard/MealCustomization.js";
import MySubscriptionsPage from "../pages/dashboard/MySubscriptionsPage.js";
import ErrorPage from "../pages/ErrorPage";

import TermsPage from "../pages/TermsPage";
import CareersListingPage from "../pages/CareersListingPage";
import CareersDetailsPage from "../pages/CareersDetailsPage";
import CareersApply from "../pages/CareersApply";
import ProductDetailsPage from "../pages/ProductDetailsPage.js";
import RecipesListingPage from "../pages/RecipesListingPage.js";
import RecipesDetailsPage from "../pages/RecipesDetailsPage.js";
import MealsPage from "../pages/MealsPage.js";
import SchoolsPage from "../pages/SchoolsPage.js";
import MealsMenuPage from "../pages/MealsMenuPage.js";
import PartyCateringPage from "../pages/PartyCateringPage.js";
import SignupPage from "../pages/SignupPage.js";
import MyOrdersPage from "../pages/dashboard/MyOrdersPage.js";
import OrderDetailsPage from "../pages/dashboard/OrderDetailsPage.js";
import OrderReviewPage from "../pages/dashboard/OrderReviewPage.js";
import OrderCancelPage from "../pages/dashboard/OrderCancelPage.js";
import ProfileManagementPage from "../pages/dashboard/ProfileManagementPage.js";
import PersonalInfoUpdatePage from "../pages/dashboard/PersonalInfoUpdatePage.js";
import ChildInfoUpdate from "../pages/dashboard/ChildInfoUpdate.js";
import AddressManagementPage from "../pages/dashboard/AddressManagementPage.js";
import ChangePasswordPage from "../pages/dashboard/ChangePasswordPage.js";
import SavedCardsPage from "../pages/dashboard/SavedCardsPage.js";
import OrderProductsReturnPage from "../pages/dashboard/OrderProductsReturnPage.js";
import CartPage from "../pages/dashboard/CartPage.js";
import CheckoutPage from "../pages/CheckoutPage.js";
import PaymentPage from "../pages/PaymentPage.js";
import NotificationsPage from "../pages/dashboard/NotificationsPage.js";
import ExpressCheckoutPage from "../pages/ExpressCheckoutPage.js";
import ExpressAddressPage from "../pages/ExpressAddressPage.js";
import SigninPage from "../pages/SigninPage.js";
import PaymentsListingPage from "../pages/dashboard/PaymentsListingPage.js";
import PaymentsDetailsPage from "../pages/dashboard/PaymentsDetailsPage.js";
import MealSubscriptionDetails from "../pages/dashboard/MealSubscriptionDetails.js";
import MealSubsctiptionCancelPage from "../pages/dashboard/MealSubsctiptionCancelPage.js";
import ForgotPassword from "../components/authPartials/ForgotPassword.js";
import ForgotPasswordPage from "../pages/ForgotPasswordPage.js";
import UpgradeMealSubsctiptionPage from "../pages/dashboard/UpgradeMealSubsctiptionPage.js";
import PaymentProcessPage from "../pages/PaymentProcessPage.js";
import PaymentReceivedPage from "../pages/PaymentReceivedPage.js";
import SubscribePlanPage from "../pages/SubscribePlanPage.js";
import SubscribeMealPage from "../pages/SubscribeMealPage.js";
import SubscribeSignInPage from "../pages/SubscribeSignInPage.js";
import SubscribeChildDetailsPage from "../pages/SubscribeChildDetailsPage.js";
import SubscribeDisclaimerPage from "../pages/SubscribeDisclaimerPage.js";
import ChangeEmail from "../components/dashboard/profilePartials/ChangeEmail.js";
import ChangeEmailPage from "../pages/dashboard/ChangeEmailPage.js";
import ChildInfoListing from "../pages/dashboard/ChildInfoListing.js";
import NotificationsDetailsPage from "../pages/dashboard/NotificationsDetailsPage.js";
import StripeOrderPayment from "../components/shopPartials/StripeOrderPayment.js";
import StripeOrderPaymentReturn from "../components/shopPartials/StripeOrderPaymentReturn.js";
import StripeMealPayment from "../components/mealsPartials/StripeMealPayment.js";
import { useAuth } from "../components/contexts/AuthContext.js";
import AddChildInfo from "../components/dashboard/profilePartials/AddChildInfo.js";
import AddChildInfoPage from "../pages/dashboard/AddChildInfoPage.js";
import DateCustomization from "../components/planPartials/DateCustomization.js";
import DateCustomizationPage from "../pages/dashboard/DateCustomizationPage.js";
import SubscribeDateSelection from "../pages/SubscribeDateSelection.js";
function AppRoutes() {
  const { isLoggedIn } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/signin" element={<SigninPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/checkout/:type" element={<CheckoutPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/payment/:type" element={<PaymentPage />} />
      <Route path="/order-payment-processor" element={<StripeOrderPayment />} />
      <Route path="/meals-payment-processor" element={<StripeMealPayment />} />
      <Route
        path="/order-payment-return"
        element={<StripeOrderPaymentReturn />}
      />
      <Route path="/process-payment/:type" element={<PaymentProcessPage />} />
      <Route
        path="/payment-received/:type/:status/:id"
        element={<PaymentReceivedPage />}
      />
      <Route
        path="/payment-received/:type/"
        element={<PaymentReceivedPage />}
      />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/meals" element={<MealsPage />} />
      <Route path="/meals/:meal" element={<MealsMenuPage />} />
      <Route path="/subscribe/plan" element={<SubscribePlanPage />} />
      <Route path="/subscribe/meals" element={<SubscribeMealPage />} />
      <Route path="/subscribe/signin" element={<SubscribeSignInPage />} />
      <Route path="/subscribe/child" element={<SubscribeChildDetailsPage />} />
      <Route path="/subscribe/date" element={<SubscribeDateSelection />} />
      <Route
        path="/subscribe/disclaimer"
        element={<SubscribeDisclaimerPage />}
      />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/school-nursery" element={<SchoolsPage />} />
      <Route path="/party-catering" element={<PartyCateringPage />} />
      <Route path="/shop/:id" element={<ProductDetailsPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/careers" element={<CareersListingPage />} />
      <Route path="/recipes" element={<RecipesListingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/news-events" element={<NewsEventsPage />} />
      <Route path="/terms" element={<TermsPage />} />

      <Route path="/careers/:id" element={<CareersDetailsPage />} />
      <Route path="/careers/apply/:id" element={<CareersApply />} />
      <Route path="/recipes/:id" element={<RecipesDetailsPage />} />
      {/* dashboard */}
      <Route
        path="/account"
        element={isLoggedIn ? <MyAccountPage /> : <SigninPage />}
      />
      <Route path="/account/subscriptions" element={<MySubscriptionsPage />} />
      <Route path="/account/orders" element={<MyOrdersPage />} />
      <Route path="/account/orders/:id" element={<OrderDetailsPage />} />
      <Route path="/account/orders/review/:id" element={<OrderReviewPage />} />
      <Route path="/account/orders/cancel/:id" element={<OrderCancelPage />} />
      <Route
        path="/account/orders/return/:id/:productId"
        element={<OrderProductsReturnPage />}
      />
      <Route
        path="/account/subscriptions/customize/:id"
        element={<MealCustomization />}
      />
        <Route
        path="/account/subscriptions/customize/date/:id"
        element={<DateCustomizationPage />}
      />
      <Route
        path="/account/subscriptions/cancel/:id"
        element={<MealSubsctiptionCancelPage />}
      />
      <Route
        path="/account/subscriptions/upgrade/:id"
        element={<UpgradeMealSubsctiptionPage />}
      />
      <Route
        path="/account/subscriptions/:id"
        element={<MealSubscriptionDetails />}
      />
      <Route path="/account/profile" element={<ProfileManagementPage />} />
      <Route
        path="/account/profile/personal-info"
        element={<PersonalInfoUpdatePage />}
      />
      <Route
        path="/account/profile/child-info"
        element={<ChildInfoListing />}
      />
       <Route
        path="/account/profile/add-child"
        element={<AddChildInfoPage />}
      />
      <Route
        path="/account/profile/edit-child/:id"
        element={<ChildInfoUpdate />}
      />
      <Route
        path="/account/profile/address-management"
        element={<AddressManagementPage />}
      />
      <Route
        path="/account/profile/change-password"
        element={<ChangePasswordPage />}
      />
      <Route
        path="/account/profile/change-email"
        element={<ChangeEmailPage />}
      />
      <Route
        path="/account/profile/payment-cards"
        element={<SavedCardsPage />}
      />
      <Route path="/account/cart" element={<CartPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/express-checkout" element={<ExpressCheckoutPage />} />
      <Route
        path="/express-checkout-address"
        element={<ExpressAddressPage />}
      />
      <Route path="/account/notifications" element={<NotificationsPage />} />
      <Route
        path="/account/notifications/:id"
        element={<NotificationsDetailsPage />}
      />
      <Route path="/account/payments" element={<PaymentsListingPage />} />
      <Route path="/account/payments/:id" element={<PaymentsDetailsPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default AppRoutes;
